import { useLocation, useNavigate } from 'react-router-dom';
import { SHOP_SECTION_ID, scrollToSection } from '../utils/scroll';
import { goToShop } from '../utils/shopIntent';
import type { ShopIntent } from '../utils/shopIntent';

/**
 * Sends the customer to the homepage shop section from anywhere.
 * With an intent, the matching system is pre-selected in the bundle selector.
 */
export function useShopNavigation() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (intent?: ShopIntent) => {
    if (pathname === '/') {
      if (intent) goToShop(intent);
      else scrollToSection(SHOP_SECTION_ID);
      return;
    }
    navigate(`/${intent ? `?system=${intent}` : ''}#${SHOP_SECTION_ID}`);
  };
}
